//
// SelectMetadataFieldPanel
//
// Select a metadata field to use in a filter, by searching for a group and picking
// a field.

import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { useDebounce } from '../hooks/useDebounce'
import { useStore } from '../stores'

import { VScrollView, VView } from '../appview'
import { Header, Item, Menu, MenuItem, SearchInput } from '../components'
import { MetadataFieldSubmenu } from '../menus'

export const SelectMetadataFieldPanel = observer(function SelectMetadataFieldPanel({
    doctype,
    selected,
    onSelectField,
}) {
    const { app, data, view } = useStore()

    const dataSource = doctype === 'schema' ? data.schemaMetadata : data.assetMetadata

    const [searchText, setSearchText] = useState('')
    const debouncedSearchtText = useDebounce(searchText, 200)
    const [resultGroups, setResultGroups] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(
        selected ? selected.split('.').shift() : undefined
    )
    const [resultFields, setResultFields] = useState([])
    const language = view.environment.get('language')

    useEffect(() => {
        dataSource.fetchGroups(debouncedSearchtText, language).then(results => {
            setResultGroups(results)
            if (selectedGroup && !results.includes(selectedGroup)) {
                setSelectedGroup(undefined)
            }
        })
    }, [dataSource, selectedGroup, debouncedSearchtText, language])

    useEffect(() => {
        dataSource.fetchGroupFields(selectedGroup, language).then(results => {
            setResultFields(results)
        })
    }, [dataSource, selectedGroup, language])

    const onSearchinputChange = event => {
        setSearchText(event.target.value)
    }
    const onSearchinputBlur = event => {
        setSearchText(event.target.value.trim())
    }

    const onSelectMetadataField = dottedField => {
        onSelectField && selectedGroup && onSelectField(dottedField)
    }

    const searchResults = resultGroups.length ? (
        resultGroups.map(groupName => {
            return (
                <Item
                    key={groupName}
                    selected={selectedGroup === groupName}
                    onClick={() => setSelectedGroup(groupName)}
                    onDoubleClick={() => setSelectedGroup(groupName)}
                    title={groupName}
                >
                    {groupName}
                </Item>
            )
        })
    ) : (
        <div style={{ padding: '2px 5px' }}>{app.text('No matches')}</div>
    )

    const metadatafieldSubmenu = selectedGroup ? (
        <MetadataFieldSubmenu
            groupname={selectedGroup}
            fieldnames={resultFields}
            onSelectMetadataField={onSelectMetadataField}
        />
    ) : undefined

    return (
        <VView className="actions-panel select-field-panel">
            <div className="inspector">
                <Header>{app.text('Select metadata field')}</Header>
                <VView
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        marginBottom: 2,
                    }}
                >
                    <SearchInput
                        value={searchText}
                        placeholder={app.text('Search by group name')}
                        onChange={onSearchinputChange}
                        onBlur={onSearchinputBlur}
                    />
                    <VScrollView
                        className="search-results"
                        style={{ backgroundColor: 'white' }}
                    >
                        {searchResults}
                    </VScrollView>
                </VView>
            </div>
            <Menu>
                <MenuItem submenu={metadatafieldSubmenu} disabled={!selectedGroup}>
                    {selectedGroup
                        ? app.text("Select metadata field from '{selectedGroup}'", {
                              selectedGroup,
                          })
                        : app.text('Select metadata field')}
                </MenuItem>
            </Menu>
        </VView>
    )
})
